"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.forgotPasswordConstraints = void 0;
const forgotPasswordConstraints = exports.forgotPasswordConstraints = {
  email: {
    presence: {
      allowEmpty: false
    },
    email: {
      message: "'%{value}' is not valid"
    }
  }
};